import React, { useContext, useEffect } from "react";
import { IonLabel, IonIcon, IonItem } from "@ionic/react";
import { cloudOffline } from "ionicons/icons";
import { Network } from "@capacitor/network";
import { TranslationMessagesContext } from "../util/Translations";
import { useNetworkStatusStore } from "../store/network-status";

const OnlineStatus: React.FC = () => {
  const { translatedMessages } = useContext(TranslationMessagesContext);

  const isOnline = useNetworkStatusStore((state) => state.isOnline);
  const setOnlineStatus = useNetworkStatusStore(
    (state) => state.setOnlineStatus
  );

  useEffect(() => {
    //retrieve the network status on component load
    Network.getStatus().then((status) => {
      setOnlineStatus(status.connected);
      console.log("Online Status: " + status.connected);
    });
    //add event listeners for network status changes
    Network.addListener("networkStatusChange", (status) => {
      setOnlineStatus(status.connected);
      console.log("Online Status: " + status.connected);
    });
  }, [setOnlineStatus]);

  return (
    <IonItem hidden={isOnline} color="danger">
      <IonLabel>
        {translatedMessages["Offline"]?.MessageText ||
          "Warning: you are currently offline"}
      </IonLabel>
      <IonIcon icon={cloudOffline} />
    </IonItem>
  );
};

export default OnlineStatus;
